// extracted by css-extract-rspack-plugin
export default {"wrapper":"_LMW0"};